import React from 'react';
import { PrivacyPolicy } from '../components/global/privacyPolicy';
import {Header} from '../components/global/header';
import {Footer} from '../components/global/footer';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <PrivacyPolicy />
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
